var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:{'active':_vm.checkSwitch},on:{"click":_vm.changeSwitch}})
}
var staticRenderFns = []

export { render, staticRenderFns }